import React from "react"

import {useAuth} from "../context"

export default function AdminOnly({children}) {
    let auth = useAuth()

    if (!auth.isAdmin) {
        return <div>not auth</div>
    }


    return children
}